import { render } from "./header-navigation.vue?vue&type=template&id=a1b780e2"
import script from "./header-navigation.vue?vue&type=script&lang=js"
export * from "./header-navigation.vue?vue&type=script&lang=js"

import "./header-navigation.vue?vue&type=style&index=0&id=a1b780e2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__